import { useEffect } from "react";

/**
 * RedirectSection Component
 * Automatically redirects to the specified URL when mounted
 * @param {Object} props - Component props
 * @param {string} props.url - The URL to redirect to
 */
const RedirectSection = (props) => {
	const { url } = props;
    console.log("RedirectSection mounted with URL:", props);

	useEffect(() => {
		if (url) {
			window.location.href = url;
		}
	}, [url]);

	// Return null as this component doesn't render anything visible
	return null;
};

export default RedirectSection;